import { CognitoUser } from 'amazon-cognito-identity-js';
import { CHALLENGE_SESSION_STORAGE_KEYS } from './constants';

const safeSessionStorage = {
  get: (key) => {
    try {
      return sessionStorage.getItem(key);
    } catch (_) {
      return null;
    }
  },
  set: (key, value) => {
    try {
      sessionStorage.setItem(key, String(value));
    } catch (_) {
      // ignore
    }
  },
  remove: (key) => {
    try {
      sessionStorage.removeItem(key);
    } catch (_) {
      // ignore
    }
  },
};

let lastChallengeUser = null;

export const setChallengeSessionStorage = ({ session, username, challengeName }) => {
  if (session) safeSessionStorage.set(CHALLENGE_SESSION_STORAGE_KEYS.SESSION, session);
  if (username) safeSessionStorage.set(CHALLENGE_SESSION_STORAGE_KEYS.USERNAME, username);
  if (challengeName) safeSessionStorage.set(CHALLENGE_SESSION_STORAGE_KEYS.CHALLENGE_NAME, challengeName);
};

export const clearChallengeSessionStorage = () => {
  safeSessionStorage.remove(CHALLENGE_SESSION_STORAGE_KEYS.SESSION);
  safeSessionStorage.remove(CHALLENGE_SESSION_STORAGE_KEYS.USERNAME);
  safeSessionStorage.remove(CHALLENGE_SESSION_STORAGE_KEYS.CHALLENGE_NAME);
};

const getChallengeUsernameFromStorage = () =>
  safeSessionStorage.get(CHALLENGE_SESSION_STORAGE_KEYS.USERNAME);

const getChallengeSessionFromStorage = () =>
  safeSessionStorage.get(CHALLENGE_SESSION_STORAGE_KEYS.SESSION);

export const clearActiveChallengeState = () => {
  lastChallengeUser = null;
  clearChallengeSessionStorage();
};

export const setActiveChallengeState = ({ user, username, challengeName, session }) => {
  lastChallengeUser = user;
  setChallengeSessionStorage({ session, username, challengeName });
};

export const getChallengeUserForUsername = (username, userPool) => {
  // The Cognito SDK uses `this.username` when building ChallengeResponses.
  // Only reuse the in-memory user when it matches the username we are responding for.
  if (lastChallengeUser && lastChallengeUser.username === username) {
    return lastChallengeUser;
  }
  return new CognitoUser({ Username: username, Pool: userPool });
};

export const ensureUserHasChallengeSession = ({ user, username, sessionFromCall }) => {
  const storedUsername = getChallengeUsernameFromStorage();
  const storedSession =
    storedUsername && storedUsername === username ? getChallengeSessionFromStorage() : null;

  const effectiveSession = sessionFromCall || storedSession;
  if (effectiveSession) {
    user.Session = effectiveSession;
  }

  return Boolean(user?.Session);
};
